/* =========================
   Media gallery (Perf-tuned)
   ========================= */

/* ---- helpers ---- */
function debounce(fn, wait = 150) {
  let t;
  return function (...args) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function easeInOutQuad(t) {
  return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
}

/* =========================
   swiper-slider-container
   ========================= */
var elementName = 'swiper-slider-container';
if (!customElements.get(elementName)) {
  class swiperSliderContainer extends HTMLElement {
    constructor() {
      super();

      // cache frequently used nodes
      this.swiperthumbcontainer = this.querySelector('.swiper-thumb__container');
      this.swiper = this.querySelector('.swiper');
      this.duration = 100;

      // thumb click
      this.querySelectorAll('.swiper-thumb').forEach((item) => {
        item.addEventListener("click", this.clickHandler.bind(this));
      });

      // hover lock body scroll (desktop only + non-touch)
      if (this.isTouchDevice() === false) {
        this.querySelectorAll('.swiper-thumb__container--horizontal').forEach((item) => {
          var _this = this;
          item.addEventListener("mouseenter", function () {
            if (window.innerWidth <= 1024) return false;
            if (item.scrollWidth <= _this.offsetWidth) return false;
            document.body.style.paddingRight = window.innerWidth > 1024 ? _this.getScrollbarWidth() + 'px' : '';
            document.body.classList.add('overflow-hidden');
          });
          item.addEventListener("mouseleave", function () {
            if (window.innerWidth <= 1024) return false;
            if (item.scrollWidth <= _this.offsetWidth) return false;
            document.body.classList.remove('overflow-hidden');
            document.body.style.paddingRight = '';
          });
        });
      }

      // swiper events
      if (this.swiper) {
        this.swiper.addEventListener('slide_inited', this.slideInitedCustom.bind(this), false);
        this.swiper.addEventListener('slide_changed_custom', this.slideChangedCustom.bind(this), false);
      }

      // mobile thumb sizing
      if (this.closest('.product--thumbnail_slider__mobile')) {
        this.mobileThumbSize();
      }
    }

    isTouchDevice() {
      return true == ("ontouchstart" in window || (window.DocumentTouch && document instanceof DocumentTouch));
    }

    mobileThumbSize() {
      var swiper__thumb__container = this.querySelector('.swiper-thumb__container');
      if (window.innerWidth > 576 || !swiper__thumb__container) return false;

      // debounce resize for performance
      this._onResizeThumb = debounce(this.resizeHandler.bind(this), 150);
      window.addEventListener("resize", this._onResizeThumb, { passive: true });
      this.resizeHandler();
    }

    resizeHandler() {
      var swiper__thumb__container = this.querySelector('.swiper-thumb__container');
      if (!swiper__thumb__container) return;

      // keep same logic, but safe
      var item_w = (swiper__thumb__container.offsetWidth - 10 * 4) / 5;
      swiper__thumb__container.style.setProperty('--thumb-width', `${item_w}px`);
    }

    slideInitedCustom() {
      var sect = this.closest('.shopify-section') || this.closest('.popup-modal__content__data');
      if (sect && sect.querySelector('select-option-js.active')) return false;

      var default_media_id = this.getAttribute('data-current-media-id');
      if (!default_media_id) return false;

      this.changeSlideSwiper(default_media_id, 0);
    }

    slideChangedCustom() {
      if (!this.querySelector('.swiper-slide-active [data-media-id]')) return false;

      var _this = this;

      // avoid extra layout work; just schedule minimal updates
      setTimeout(function () {
        var active = _this.querySelector('.swiper-slide-active [data-media-id]');
        if (!active) return;

        var _id = active.getAttribute('data-media-id');
        if (!_id) return;

        if (_this.querySelector('.swiper-thumb__container--horizontal') || window.innerWidth <= 1024) {
          _this.horizontaldesign(_id);
        } else {
          _this.verticaldesign(_id);
        }
      }, 0);

      setTimeout(function () {
        var active = _this.querySelector('.swiper-slide-active [data-media-id]');
        if (!active) return;
        _this.playActiveMedia(active);
      }, 100);
    }

    clickHandler(e) {
      var active = this.querySelector('.active');
      if (active) active.classList.remove('active');
      e.currentTarget.classList.add('active');

      var _id = e.currentTarget.getAttribute('data-media-id');
      if (!_id) return;

      this.changeSlideSwiper(_id);
    }

    changeSlideSwiper(_id, delay) {
      delay = delay === undefined || delay === null ? 300 : delay;

      var swiperslider = this.querySelector('swiper-slider');
      if (!swiperslider) return;

      var target = swiperslider.querySelector(`[data-media-id="${_id}"]`);
      if (!target) return;

      var item_img = target.closest('.swiper-slide');
      if (!item_img || !item_img.parentNode) return;

      const nodes = Array.prototype.slice.call(item_img.parentNode.childNodes);
      var index = nodes.indexOf(item_img);

      // normalize index based on first swiper-slide node
      var sw = swiperslider.querySelectorAll(`.swiper-slide`)[0];
      if (!sw || !sw.parentNode) return;

      const sw_nodes = Array.prototype.slice.call(sw.parentNode.childNodes);
      const sw_index = nodes.indexOf(sw); // keep original logic as theme expects
      index = index - sw_index;

      var swiperEl = this.querySelector('.swiper');
      if (!swiperEl || typeof swiperEl.selectSlide !== 'function') return;

      swiperEl.selectSlide(index, delay);
    }

    changeSlide(_id) {
      if (this.querySelector('.swiper-thumb__container--horizontal') || window.innerWidth <= 1024) {
        this.horizontaldesign(_id);
      } else {
        this.verticaldesign(_id);
      }
      this.changeSlideSwiper(_id);
    }

    verticaldesign(_id) {
      if (!this.swiperthumbcontainer) return false;

      var item = this.swiperthumbcontainer.querySelector(`[data-media-id="${_id}"]`);
      if (!item) return false;

      var active = this.swiperthumbcontainer.querySelector('.active');
      if (active) active.classList.remove('active');
      item.classList.add('active');

      var _y = item.offsetTop - this.swiperthumbcontainer.offsetTop,
        _h = this.swiperthumbcontainer.offsetHeight,
        main_scrolltop = this.swiperthumbcontainer.scrollTop,
        item_y = _y - main_scrolltop + item.offsetHeight;

      var temp = 0;
      if (item_y > _h) {
        temp = main_scrolltop + (item_y - _h);
        this.scrollTo(this.swiperthumbcontainer, temp, this.duration, 'scrollTop');
      } else if (_y < main_scrolltop) {
        temp = this.swiperthumbcontainer.scrollTop - (main_scrolltop - _y);
        this.scrollTo(this.swiperthumbcontainer, temp, this.duration, 'scrollTop');
      }
    }

    horizontaldesign(_id) {
      if (!this.swiperthumbcontainer) return false;

      var item = this.swiperthumbcontainer.querySelector(`[data-media-id="${_id}"]`);
      if (!item) return false;

      var active = this.swiperthumbcontainer.querySelector('.active');
      if (active) active.classList.remove('active');
      item.classList.add('active');

      var _x = item.offsetLeft - this.swiperthumbcontainer.offsetLeft,
        _w = this.swiperthumbcontainer.offsetWidth,
        main_scrollleft = this.swiperthumbcontainer.scrollLeft,
        item_x = _x - main_scrollleft + item.offsetWidth;

      var temp = 0;
      var delta = window.innerWidth <= 576 ? 15 : 0;

      if (item_x > _w) {
        temp = main_scrollleft + (item_x - _w) + delta;
        this.scrollTo(this.swiperthumbcontainer, temp, this.duration, 'scrollLeft');
      } else if (_x < main_scrollleft) {
        temp = this.swiperthumbcontainer.scrollLeft - (main_scrollleft - _x) + delta;
        this.scrollTo(this.swiperthumbcontainer, temp, this.duration, 'scrollLeft');
      }
    }

    playActiveMedia(activeItem) {
      if (!activeItem || !activeItem.parentNode) return;
      const deferredMedia = activeItem.parentNode.querySelector('.deferred-media');
      if (deferredMedia && typeof deferredMedia.loadContent === 'function') {
        deferredMedia.loadContent(false);
      }
    }

    // ✅ rAF scroll (lighter than setTimeout loop)
    scrollTo(el, to, duration, option) {
      if (!el) return;

      const start = el[option];
      const change = to - start;
      const startTime = performance.now();

      const step = (now) => {
        const elapsed = now - startTime;
        const t = Math.min(elapsed / duration, 1);
        el[option] = start + change * easeInOutQuad(t);
        if (t < 1) requestAnimationFrame(step);
      };

      requestAnimationFrame(step);
    }

    getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    }
  }

  customElements.define('swiper-slider-container', swiperSliderContainer);
}

/* =========================
   theme-lightbox (Perf-tuned)
   ========================= */
elementName = 'theme-lightbox';
if (!customElements.get(elementName)) {
  class themeLightbox extends HTMLElement {
    constructor() {
      super();

      // debounce resize; attach only while open
      this._onResize = debounce(this.resizeHandler.bind(this), 150);

      const toggle = this.querySelector('.theme-lightbox__toggle');
      if (toggle) toggle.addEventListener("click", this.close.bind(this), false);
    }

    resizeHandler() {
      const images = this.querySelectorAll('.theme-lightbox__image');
      if (!images || !images.length) return;

      const ww = window.innerWidth - 218;
      const wh = window.innerHeight - 136;

      images.forEach((item) => {
        const iw = item.naturalWidth || 0;
        const ih = item.naturalHeight || 0;
        if (!iw || !ih) return;

        const wr = ww / iw;

        if (iw > ih) {
          if (ih * wr >= wh) item.classList.remove('theme-lightbox__image--wide');
          else item.classList.add('theme-lightbox__image--wide');
        }
      });
    }

    open(data_media_id) {
      this.classList.add('active');
      setTimeout(() => {
        this.classList.add('animate');
      }, 0);

      document.body.style.paddingRight = this.getScrollbarWidth() + 'px';
      document.body.classList.add('overflow-hidden');

      // ✅ attach resize only now
      window.addEventListener("resize", this._onResize, { passive: true });
      this.resizeHandler();

      const target = this.querySelector(`[data-media-id="${data_media_id}"]`);
      const item_img = target ? target.closest('.swiper-slide') : null;
      if (!item_img || !item_img.parentNode) return;

      const nodes = Array.prototype.slice.call(item_img.parentNode.childNodes);
      const index = nodes.indexOf(item_img);

      const sw = this.querySelector('.swiper');
      if (sw && typeof sw.selectSlide === 'function') {
        sw.selectSlide(index);
      }
    }

    close() {
      this.classList.remove('animate');
      setTimeout(() => {
        this.classList.remove('active');
      }, 500);

      document.body.classList.remove('overflow-hidden');
      document.body.style.paddingRight = '';

      if (window.pauseAllMedia) window.pauseAllMedia();

      // ✅ detach resize when closed
      window.removeEventListener("resize", this._onResize);
    }

    getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    }
  }

  customElements.define('theme-lightbox', themeLightbox);
}

/* =========================
   lightbox-opener
   ========================= */
elementName = 'lightbox-opener';
if (!customElements.get(elementName)) {
  class lightboxOpener extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", this.clickHandler.bind(this));
    }
    clickHandler() {
      var id = this.getAttribute('data-id');
      var item = id ? document.getElementById(id) : null;
      var data_media_id = this.getAttribute('data-media-id');

      if (item && typeof item.open === 'function') {
        item.open(data_media_id);
      }
    }
  }
  customElements.define('lightbox-opener', lightboxOpener);
}